import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-container scrollable" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-download",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" })
], -1)
const _hoisted_3 = { class: "stat-container" }

import { OrderStats, ProductStats, ProductUsageModel } from '@/types/Stats';
import { ref } from 'vue';
import http from '@/services/AxiosClient';

export default /*#__PURE__*/_defineComponent({
  __name: 'Stats',
  setup(__props) {
const productsCsvUri = process.env.VUE_APP_API_BASE+"/Stats/Products.csv";

const products = ref([] as ProductUsageModel[]);
const count = ref(0);
const totalUsage = ref(0);
const orderStats = ref<OrderStats>({averageFinish:0,fastestFinish:0,finishedOrdersCount:0,slowestFinish:0,totalCost:0,unfinishedOrdersCount:0})
async function loadProductStats(){
    const results = await http.get("Stats/Products");
    const stat:ProductStats = results.data;
    console.log(stat);
    products.value = stat.products;
    count.value = stat.count;
    totalUsage.value = stat.totalUsage;
}
async function loadOrderStats(){
    const results = await http.get("Stats/Orders");
    const stat:OrderStats = results.data;
    console.log(stat);
    orderStats.value = stat;
}
loadProductStats();
loadOrderStats();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, "Počet objednávek: " + _toDisplayString(orderStats.value.finishedOrdersCount+orderStats.value.unfinishedOrdersCount) + " z toho " + _toDisplayString(orderStats.value.unfinishedOrdersCount) + " nedokončených", 1),
    _createElementVNode("span", null, "Průměrná délka dokončení obejdnávky: " + _toDisplayString(orderStats.value.averageFinish) + " - Nejrychlejší: " + _toDisplayString(orderStats.value.fastestFinish) + " - Nejpomalejší: " + _toDisplayString(orderStats.value.slowestFinish), 1),
    _createElementVNode("span", null, "Celkově utraceno: " + _toDisplayString(orderStats.value.totalCost.toFixed(2)) + " Kč", 1),
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        href: productsCsvUri,
        class: "btn btn-outline-primary btn-sm my-1"
      }, [
        _hoisted_2,
        _createTextVNode(" Stáhnout CSV produktů ")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "stat-product",
          key: product.product.id
        }, [
          _createElementVNode("h5", null, _toDisplayString(product.product.name), 1),
          _createElementVNode("p", null, _toDisplayString(product.product.price.toFixed(2)) + " Kč", 1),
          _createElementVNode("p", null, " Objednán " + _toDisplayString(product.usage) + "x krát", 1),
          _createElementVNode("p", null, " Celkově " + _toDisplayString(product.total.toFixed(2)) + " Kč", 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})